import { useSession, useUserMetadata } from 'src/hooks';
import { useMemo } from 'react';
import { useGetSettingsQuery } from 'src/store/services/userSettingsApi';
import { SettingKeys, SettingLLMModels } from 'src/types/settings';
import { settingKeyToRootKey } from 'src/utils/settings';
import { prepareModelsList } from 'src/utils';

// TODO(olha): this hook cover well only one case when SettingKey consist of two keys
export const useUserSettings = <T>(
  settingKey: SettingKeys,
  fullSettingsKey?: boolean,
): {
  setting: T | undefined;
  superAgentModels: SettingLLMModels;
  otherLLMModels: SettingLLMModels;
} => {
  const {
    appUser: { user_id },
  } = useSession();

  const { metadata } = useUserMetadata();

  const { settings } = useGetSettingsQuery(
    {
      user_id,
      settingKey: fullSettingsKey
        ? settingKey
        : settingKeyToRootKey(settingKey),
    },
    {
      skip: !user_id,
      selectFromResult: ({ data }) => ({
        settings: data?.settings,
      }),
    },
  );

  const setting = settings ? settings[settingKey] || settings : undefined;

  const superAgentModels = useMemo(() => {
    if (setting?.options) {
      return prepareModelsList(setting?.options, metadata).filter(
        (item) => item.id.includes('/super-agent'), // todo it is temporary till BE implements groups
      );
    }
    return [];
  }, [setting, metadata]);

  const otherLLMModels = useMemo(() => {
    if (setting?.options) {
      return prepareModelsList(setting?.options, metadata).filter(
        (item) => !item.id.includes('agent/ninjatech/text-auto'), // todo it is temporary till BE implements groups
      );
    }
    return [];
  }, [setting, metadata]);

  return useMemo(
    () => ({
      setting: setting as T,
      superAgentModels,
      otherLLMModels,
    }),
    [setting, superAgentModels, otherLLMModels],
  );
};
